import { store } from '~state/ReduxWrapper';

import axios from '~utils/axios';
import { navigate } from 'gatsby';
import {
  handleSubmitError,
  prepareDataForSubmit,
} from '../forms/SubmissionHelpers';
import updateDataLayer from '../../utils/events';

function postCompletionToTurnout(tool = 'register') {
  const { person, sourcing, registerFields, futurevoterFields } =
    store.getState();
  const { subscriber } = sourcing;

  const fields = tool === 'register' ? registerFields : futurevoterFields;

  // todo - make sure completion gets posted for ineligible age on futurevoter
  const values = {
    referring_tool: fields.referring_tool,
    uuid: fields.uuid,
    region: fields.region,
    state: person.state,
  };

  const params = { ...values };

  const submitData = prepareDataForSubmit(params);

  const patchUrl =
    tool === 'futurevoter'
      ? `futurevoter/start-registration/${params.uuid}/?subscriber=${subscriber}`
      : `registration/register/${params.uuid}/?subscriber=${subscriber}`;

  try {
    axios.patch(patchUrl, submitData);
  } catch (error) {
    handleSubmitError(error, values, null);
  }

  return values;
}

export function sendRegistrationForm(isFollowUp = false, tool = 'register') {
  const { person, registerFields, futurevoterFields } = store.getState();
  const fields = tool === 'futurevoter' ? futurevoterFields : registerFields;

  try {
    const values = postCompletionToTurnout(tool);

    const fieldsKeys = Object.keys(fields);
    const fieldsUpdate = {
      formRequested: true,
    };

    fieldsKeys.forEach((key) => {
      if (values[key]) {
        fieldsUpdate[key] = values[key];
      }
    });

    store.dispatch({
      type:
        tool === 'futurevoter'
          ? 'FUTUREVOTER_UPDATE_FIELDS'
          : 'REGISTER_UPDATE_FIELDS',
      registerFields: fieldsUpdate,
    });

    const event = isFollowUp ? 'action-follow-up' : 'action-finish';

    updateDataLayer({
      event,
      method: 'pdf',
      tool,
      state: person.state,
      first_name: person.first_name,
      last_name: person.last_name,
      email: person.email,
      zipcode: person.zipcode,
      url: undefined,
    });

    navigate(`/tools/${tool}/download-pdf/`);
  } catch (error) {
    handleSubmitError(error, null, null);
  }
}

export function completeRegisterIneligible(
  tool = 'register',
  reason = 'state'
) {
  const { person } = store.getState();

  try {
    postCompletionToTurnout(tool);

    updateDataLayer({
      event: 'action-finish',
      method: `ineligible-${reason}`,
      tool,
      state: person.state,
      first_name: person.first_name,
      last_name: person.last_name,
      email: person.email,
      zipcode: person.zipcode,
      url: undefined,
    });

    navigate(`/tools/${tool}/ineligible-${reason}/`);
  } catch (error) {
    handleSubmitError(error, {}, null);
  }
}
